import { faqs } from '@/mocks/data';

export default function FAQSection() {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 mt-2">关于小蓝视频，你可能想了解这些</p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <details
                key={index}
                className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
              >
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors duration-200 list-none">
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                    {faq.question}
                  </h3>
                  <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 group-open:bg-primary-100 group-open:text-primary-600 transition-colors duration-200">
                    <i className="ri-arrow-down-s-line text-sm group-open:rotate-180 transition-transform duration-200"></i>
                  </div>
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}